module.exports = __webpack_public_path__ + "img/brushes-cn-hero.e7c042a.jpg";